import React from 'react';
import './style.css';

const Sidebar = ({ capitulos, currentChapterIndex, setCurrentChapterIndex, isSidebarOpen, setIsSidebarOpen }) => {
  const handleKeyDown = (index, event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      setCurrentChapterIndex(index + 1);
      setIsSidebarOpen(false);
    }
  };

  return (
    <>
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
          onClick={() => setIsSidebarOpen(false)}
        ></div>
      )}

      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 min-h-full w-64 bg-slate-800 shadow-lg transform transition-transform duration-300 ${
          isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } md:translate-x-0 z-40`}
      >
        <div className="flex flex-col justify-between h-full p-6">
          {/* Encabezado del sidebar */}
          <div>
            <h2 className="text-xl font-bold text-purple-400 mb-6">Pistas</h2>
            {/* Lista de pistas */}
            <ul
              className="space-y-4 overflow-y-auto max-h-550 2xl:max-h-650 border border-purple-400/20 rounded-lg p-2 scrollbar-transparent"
              role="list"
              aria-label="Lista de pistas del audiolibro"
            >
              {capitulos.map((chapter, index) => {
                const chapterIndex = index + 1;
                return (
                  <li
                    key={index}
                    tabIndex={0}
                    onClick={() => {
                      if (currentChapterIndex === chapterIndex) {
                        console.log("El capítulo seleccionado ya está en reproducción.");
                        setIsSidebarOpen(false);
                        return;
                      }

                      setCurrentChapterIndex(chapterIndex);
                      setIsSidebarOpen(false);
                    }}
                    onKeyDown={(event) => handleKeyDown(index, event)}
                    className={`flex items-center space-x-2 text-white cursor-pointer hover:text-purple-400 focus:outline-none focus:bg-purple-400 focus:text-black ${
                      currentChapterIndex === chapterIndex
                        ? 'text-purple-400 font-bold bg-slate-700 rounded-md p-2'
                        : ''
                    }`}
                    role="option"
                    aria-selected={currentChapterIndex === chapterIndex}
                  >
                    <span>{chapter.nombre}</span>
                  </li>
                );
              })}
            </ul>
          </div>
          {/* Botón para cerrar el sidebar en dispositivos móviles */}
          <button
            onClick={() => setIsSidebarOpen(false)}
            className="md:hidden text-white hover:text-purple-400 self-end"
          >
            Cerrar
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;